import { Observable } from 'rxjs/Observable';
import { Injectable, Injector } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { UserConfigService } from './userConfig.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CommonService } from './common.service';
import { retry, catchError, retryWhen, mergeMap } from 'rxjs/operators';
import { throwError, timer } from 'rxjs';
import { DataSharingService } from './DataSharing.service';

@Injectable()

@Injectable({
  providedIn: 'root'
})
export class HeaderInterceptorService implements HttpInterceptor {

  constructor(private userConfigService: UserConfigService,
    private router: Router, private translateServcie: TranslateService,
    private commonService: CommonService,
    private sharedDataService:DataSharingService) {

    // this.router.events
    // .pipe(filter((rs): rs is NavigationEnd => rs instanceof NavigationEnd))
    // .subscribe(event => {
    //   if (
    //     event.id === 1 &&
    //     event.url === event.urlAfterRedirects
    //   ) {
    //     var userType=  localStorage.getItem("UserType");
    //     var userId=localStorage.getItem('UserId');
    //     var userCpr=localStorage.getItem('UserCpr');
    //     this.userConfigService.setUserConfig(userType,userId,userCpr);

    //   }
    // })
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // this.sharedDataService.isUserLoggedIn.next(this.userConfigService.isLoggedIn());
    // this.sharedDataService.userName.next(this.userConfigService.getUserName());
    let currentLang = "en";
    let access_token = sessionStorage.getItem('Access-Token') || '';
    let lang = localStorage.getItem('lang') || currentLang;
    let userYype = this.userConfigService.getUserType() || '';
    // 
    // let sessionId = this.cookie.get('SessionId');
    let authReq = req.clone({
       withCredentials: true,
      headers: req.headers
        .append('Accept-Languagee', lang)
        .append('Authorization', 'Bearer ' + access_token)
        .append('Access-Control-Allow-Origin' , '*')
      // .append('Cookie', sessionId)
    });
    if (authReq && authReq.headers) {
      authReq.headers.get('Accept-Languagee');
      authReq.headers.get('Authorization');
    }
    // return next.handle(authReq)
    //   .pipe(
    //     retry(1),
    //     catchError((error: HttpErrorResponse) => {
    //       this.commonService.catchError(error);
    //       return throwError(error);

    //     })
    //   )
      return next.handle(authReq)
      .pipe(retryWhen(errors =>
    errors.pipe(
      mergeMap((error: HttpErrorResponse, retryCount: number) => {
        // Retry only once and only on specific status codes
        if (retryCount < 1 && (error.status === 500 || error.status === 503)) {
          return timer(1000); // Delay before retry (1 second)
        }
        // return throwError(() => error); // No retry, propagate error
        throw error; // No retry, propagate error
      })
    )
  ),
  catchError((error: HttpErrorResponse) => {
    this.commonService.catchError(error);
    return throwError(() => error);
  })
      )
  }

}
